import { Autocomplete, Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Grid, IconButton, InputLabel, Menu, MenuItem, Pagination, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField } from "@mui/material";
import { Fragment, useEffect, useRef, useState } from "react";
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ModeEditIcon from '@mui/icons-material/ModeEdit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import InventoryService from "src/_cores/_services/inventory.service";
import { api } from "src/_cores/_api/api";
import { SALES_API_URL } from "src/_cores/_enums/api-url.enum";
import { DateTimeHelper } from "src/_shares/_helpers/datetime-helper";
import UserService from "src/_cores/_services/user.service";
import { IUserGetParam } from "src/_pages/admin/interfaces/user-interface";
import { Replay } from "@mui/icons-material";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const ShopList = () => {
    const editorRef = useRef<any>(null);
    const [filterUsers, setFilterUsers] = useState<any[]>([]);
    const [filterShopUsers, setFilterShopUsers] = useState<any[]>([]);
    const [totalPages, setTotalPages] = useState<number>(1);
    const [open, setOpen] = useState(false);
    const [selectedShopId, setSelectedShopId] = useState(-1);
    const [delAnchorEl, setDelAnchorEl] = useState<null | HTMLElement>(null);
    const [slAnchorEl, setSlAnchorEl] = useState<null | HTMLElement>(null);
    const openDel = Boolean(delAnchorEl);
    const uploadRef = useRef<any>();

    const [params, setParams] = useState<any>({
        pageIndex: 1,
        pageSize: 10,
        searchKey: '',
        userNames: [],
        shopUserNames: [],
        status: 1,
    });

    const [brands, setBrands] = useState([]);
    const [users, setUsers] = useState([]);
    const [shops, setShops] = useState([]);
    const [formData, setFormData] = useState<{ [key: string]: any }>();

    useEffect(() => {
        async function getBrands() {
            const res = await InventoryService.getBrands({}) as any;
            if (res?.isSucceed) {
                setBrands(res.data);
            }
        }
        async function getUsers() {
            const params = {
                pageIndex: 1,
                pageSize: 1000,
            } as IUserGetParam
            const res = await UserService.getUserList(params) as any;
            if (res?.isSucceed) {
                setUsers(res.data.items);
            }
        }
        getBrands();
        getUsers();
        getData(params);
    }, []);

    const handleClose = () => {
        setFormData({});
        setOpen(false);
    };

    const onChangeFilterUsers = (items: any[]) => {
        const _userNames = items.map(_ => _.userName) as any;
        setFilterUsers(_userNames);
        const _params = { ...params, userNames: _userNames || [] };
        setParams(_params);
        getData(_params);
    }

    const onChangeFilterShopUsers = (items: any[]) => {
        const _userNames = items.map(_ => _.userName) as any;
        setFilterShopUsers(_userNames);
        const _params = { ...params, shopUserNames: _userNames || [] };
        setParams(_params);
        getData(_params);
    }

    const onChangeFilterStatus = (event: any) => {
        const value = event.target.value;
        const _params = { ...params, status: value === '' ? null : Number(value), pageIndex: 1 };
        setParams(_params);
        getData(_params);
    }

    const onChangeInput = (type: 'searchKey', event: any) => {
        const _params = { ...params, [type]: event?.target?.value || '' };
        setParams(_params);
    }

    const pageChange = (event: any, pageIndex: number) => {
        const _params = { ...params, pageIndex: pageIndex || 1 };
        setParams(_params);
        getData(_params);
    }

    const handleChange = (e: any) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };

    const onChangeFiles = (files: string[]) => {
        console.log(files);
        setFormData({ ...formData, imagePath: files[0] ?? '' });
    }

    const onChangeBrands = (items: any[]) => {
        const _ids = items.map(_ => _.id);
        setFormData({ ...formData, shopBrands: _ids });
    }

    const onChangeUsers = (items: any[]) => {
        const _ids = items.map(_ => _.userId);
        setFormData({ ...formData, shopUsers: _ids });
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const viewDetail = async (id: number) => {
        const res = await api.get(SALES_API_URL.GET_SHOP + `/${id}`) as any;
        if (res) {
            const dataDetail = {
                ...res,
                shopBrands: res.shopBrands?.map((_: any) => _.id) || [],
                shopUsers: res.shopUsers?.map((_: any) => _.id) || [],
            } as any;
            setFormData(dataDetail);
            handleClickOpen();
        }
    }

    const openShopUsers = (event: React.MouseEvent<HTMLElement>) => {
        setSlAnchorEl(event.currentTarget);
    }

    const viewShopUsers = async (id: number) => {
        setSelectedShopId(id);
        const res = await api.get(SALES_API_URL.GET_SHOP + `/${id}`) as any;
        if (res) {
            const dataDetail = res as any;
            setFormData(dataDetail);
        }
    }

    const updateStatus = async (id: number, status: number) => {
        if (!window.confirm("Bạn có chắc muốn cập nhật không?")) return;
        const query = '?id=' + id + '&status=' + status;
        const res = await api.post(SALES_API_URL.UPDATE_SHOP_STATUS + query) as any;
        if (res?.isSucceed) {
            await getData(params);
        }
        handleClose();
        setDelAnchorEl(null);
    }

    const onChangeIsHighlight = (event: any) => {
        setFormData({ ...formData, isHighlight: event.target.checked });
    }

    const handleSubmit = async (e: any) => {
        e.preventDefault();
        const params = {
            ...formData,
            id: formData?.shopId,
            name: formData?.shopName,
            brandIds: formData?.shopBrands || [],
        }
        const url = formData?.shopId > -1
            ? SALES_API_URL.UPDATE_SHOP
            : SALES_API_URL.ADD_SHOP;
        const res = await api.post(url, params) as any
        if (res?.isSucceed)
            await getData(params);
        handleClose();
    };

    const getData = async (_params: any) => {
        const response = await api.post(SALES_API_URL.SHOP_PAGING, _params) as any;
        if (response?.isSucceed) {
            setShops(response.data?.items);
            setTotalPages(response.data?.totalPages);
        }
    }

    const closeDialogAndRemoveFiles = () => {
        handleClose();
        if (uploadRef.current) {
            //uploadRef.current.removeAllFiles();
        }
    }

    return (
        <Fragment>
            <Box>
                <Grid container spacing={2} sx={{ marginBottom: 2 }}>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={users}
                            disableCloseOnSelect
                            getOptionLabel={(item: any) => `${item.userId} - ${item.userFullName}`}
                            value={
                                users.length > 0 && filterUsers
                                    ? users.filter((item: any) => filterUsers.some((_: any) => _ === item.userName))
                                    : []
                            }
                            renderOption={(props, item: any, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        size="small"
                                    />
                                    {item.userId} - {item.userFullName}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Người để liên hệ" placeholder="Chọn người để liên hệ" size="small" />
                            )}
                            onChange={(event, items: any) => onChangeFilterUsers(items)}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={users}
                            disableCloseOnSelect
                            getOptionLabel={(item: any) => `${item.userId} - ${item.userFullName}`}
                            value={
                                users.length > 0 && filterShopUsers
                                    ? users.filter((item: any) => filterShopUsers.some((_: any) => _ === item.userName))
                                    : []
                            }
                            renderOption={(props, item: any, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        size="small"
                                    />
                                    {item.userId} - {item.userFullName}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Người dùng" placeholder="Chọn người dùng" size="small" />
                            )}
                            onChange={(event, items: any) => onChangeFilterShopUsers(items)}
                            size="small"
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField className="w-full" label="Tìm kiếm" placeholder="Nhập để tìm" size="small" onChange={(event: any) => onChangeInput('searchKey', event)} />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl fullWidth size="small">
                            <InputLabel>Trạng thái</InputLabel>
                            <Select
                                label="Trạng thái"
                                value={params.status === null ? '' : String(params.status)}
                                onChange={onChangeFilterStatus}
                            >
                                <MenuItem value="">Tất cả</MenuItem>
                                <MenuItem value="1">Hoạt động</MenuItem>
                                <MenuItem value="0">Đã khóa</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={12}>
                        <Button variant="contained" sx={{ marginRight: 2 }} onClick={() => getData(params)}>Xem</Button>
                        <Button variant="contained" sx={{ marginRight: 2 }} onClick={handleClickOpen}>Thêm</Button>
                    </Grid>
                </Grid>
            </Box>
            <TableContainer component={Paper} sx={{ marginBottom: 2 }}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell>Ngày tham gia</TableCell>
                            <TableCell>Tên</TableCell>
                            <TableCell>Tên người để liên hệ</TableCell>
                            <TableCell>Danh sách người dùng</TableCell>
                            <TableCell>Trạng thái</TableCell>
                            <TableCell></TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {shops.map((_: any) => (
                            <TableRow key={_.shopId} sx={{ '& > *': { borderBottom: 'unset' } }}>
                                <TableCell>{DateTimeHelper.getDateTimeFormated(_.shopJoinDate)}</TableCell>
                                <TableCell>{_.shopName}</TableCell>
                                <TableCell>{_.userFullName}</TableCell>
                                <TableCell>
                                    <Button
                                        id={`shop-user-list-${_.shopId}`}
                                        aria-haspopup="true"
                                        aria-controls={slAnchorEl && selectedShopId === _.shopId ? `shop-user-list-menu-${_.shopId}` : undefined}
                                        aria-expanded={slAnchorEl && selectedShopId === _.shopId ? 'true' : undefined}
                                        onClick={(event) => {
                                            openShopUsers(event);
                                            viewShopUsers(_.shopId)
                                        }}
                                    >
                                        Xem
                                    </Button>
                                    <Menu
                                        id={`shop-user-list-menu-${_.shopId}`}
                                        anchorEl={slAnchorEl}
                                        open={selectedShopId === _.shopId}
                                        onClose={() => {
                                            setSlAnchorEl(null);
                                            setSelectedShopId(-1);
                                        }}
                                        MenuListProps={{
                                            'aria-labelledby': `shop-user-list-${_.shopId}`,
                                        }}
                                    >
                                        {users.length > 0 && formData?.shopUsers
                                            ? users
                                                .filter((item: any) => formData?.shopUsers.map((_: any) => _.id).includes(item.userId))
                                                .map((item: any) => (
                                                    <MenuItem key={item.userId}>{item.userId} - {item.userFullName}</MenuItem>
                                                ))
                                            : null}
                                    </Menu>
                                </TableCell>
                                <TableCell>{_.status === 0 ? 'Đã khóa' : ''}</TableCell>
                                <TableCell>
                                    <IconButton
                                        size="small"
                                        onClick={() => viewDetail(_.shopId)}
                                    >
                                        <ModeEditIcon />
                                    </IconButton>
                                    <IconButton
                                        size="small"
                                        aria-haspopup="true"
                                        aria-controls={openDel ? 'basic-menu' : undefined}
                                        aria-expanded={openDel ? 'true' : undefined}
                                        onClick={() => updateStatus(_.shopId, _.status === 0 ? 1 : 0)}
                                    >
                                        {_.status === 0 ? <Replay /> : <DeleteOutlineIcon />}
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
            <Pagination
                variant="outlined"
                shape="rounded"
                page={params.pageIndex}
                count={totalPages}
                onChange={pageChange}
            />

            <Dialog
                fullWidth={true}
                open={open}
                onClose={closeDialogAndRemoveFiles}
                PaperProps={{ style: { height: '80vh' } }}
            >
                <Box component={'form'} onSubmit={handleSubmit}>
                    <DialogTitle>Chi tiết</DialogTitle>
                    <DialogContent>
                        <TextField
                            required
                            margin="dense"
                            name="shopName"
                            label="Tên cửa hàng"
                            type="text"
                            fullWidth
                            variant="standard"
                            sx={{ marginBottom: 2 }}
                            value={formData?.shopName || ''}
                            onChange={(e) => handleChange(e)}
                        />
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={brands}
                            disableCloseOnSelect
                            getOptionLabel={(item: any) => `${item.id} - ${item.name}`}
                            value={brands.length > 0 && formData?.shopBrands ? brands.filter((item: any) => formData?.shopBrands.includes(item.id)) : []}
                            renderOption={(props, item: any, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        size="small"
                                    />
                                    {item.id} - {item.name}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Thương hiêu" placeholder="Chọn thương hiệu" size="small" />
                            )}
                            onChange={(event, items: any) => onChangeBrands(items)}
                            size="small"
                        />
                        <TextField
                            required
                            type="number"
                            margin="dense"
                            name="tax"
                            label="Chiết khấu"
                            fullWidth
                            variant="standard"
                            sx={{ marginBottom: 2 }}
                            value={formData?.tax || 0}
                            onChange={(e) => handleChange(e)}
                        />
                        <Autocomplete
                            multiple
                            id="checkboxes-tags-demo"
                            options={users}
                            disableCloseOnSelect
                            getOptionLabel={(item: any) => `${item.userId} - ${item.userFullName}`}
                            value={users.length > 0 && formData?.shopUsers ? users.filter((item: any) => formData?.shopUsers.includes(item.userId)) : []}
                            renderOption={(props, item: any, { selected }) => (
                                <li {...props}>
                                    <Checkbox
                                        icon={icon}
                                        checkedIcon={checkedIcon}
                                        style={{ marginRight: 8 }}
                                        checked={selected}
                                        size="small"
                                    />
                                    {item.userId} - {item.userFullName}
                                </li>
                            )}
                            renderInput={(params) => (
                                <TextField {...params} label="Người dùng" placeholder="Chọn người dùng" size="small" />
                            )}
                            onChange={(event, items: any) => onChangeUsers(items)}
                            size="small"
                        />
                        {/* <TextField
                            required
                            margin="dense"
                            name="shopBankName"
                            label="Tên ngân hàng"
                            type="text"
                            fullWidth
                            variant="standard"
                            sx={{ marginBottom: 2 }}
                            value={formData?.shopBank?.shopBankName || ''}
                            onChange={(e) => handleChange(e)}
                        />
                        <TextField
                            required
                            margin="dense"
                            name="shopAccountName"
                            label="Tên tài khoản"
                            type="text"
                            fullWidth
                            variant="standard"
                            sx={{ marginBottom: 2 }}
                            value={formData?.shopBank?.shopAccountName || ''}
                            onChange={(e) => handleChange(e)}
                        />
                        <TextField
                            required
                            margin="dense"
                            name="shopAccountNumber"
                            label="Số tài khoản"
                            type="text"
                            fullWidth
                            variant="standard"
                            sx={{ marginBottom: 2 }}
                            value={formData?.shopBank?.shopAccountNumber || ''}
                            onChange={(e) => handleChange(e)}
                        /> */}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={closeDialogAndRemoveFiles}>Đóng</Button>
                        <Button type="submit">Xác nhận</Button>
                    </DialogActions>
                </Box>
            </Dialog>
        </Fragment>
    )
}

export default ShopList;